<template>
  <div :class="isSushiHub && 'montserrat-500'" :style="isSushiHub? desktopStyles.sushiBackground : desktopStyles.menu">

    <sushi-nav v-if="isSushiHub" />
    <!--Coupons-->
    <shop-header :store-id="storeid" :sushiHub="isSushiHub" />

    <div
        :class="{'background-sushi-blue position-relative' : isSushiHub}">



    <section class="bg-white position-sticky" style="top:-1px;z-index:4"  >
      <div class="container-fluid" :style="!isSushiHub? desktopStyles.nav : desktopStyles.sushiNav" v-if="getloadedMenu"  >
        <div class="container" ref="container" v-if="storeMenu"  >
          <resturant-menu :categories="storeMenu.Categories" :sushiHub="isSushiHub" />
        </div>
      </div>
    </section>

    <div class="container root">
      <div class="row main-container" v-if="storeMenu && getloadedMenu">
        <main :class="computeProductListClass">
          <ProductList :menu="setMenu()" @update-containerWidth="p=>updateWidth(p)" :isSushi="isSushiHub" />
        </main>
        <aside v-if="!isDigitalDisplay" :class="shoppingCartClass" id="shopping-cart">
          <div
            class="category-title"
            v-if="storeMenu.Categories && storeMenu.Categories.length > 0"
          />
          <ShoppingCart :isFromHomePage="true" :isSushi="isSushiHub" />
        </aside>
      </div>
    </div>


  <TermsAndCondition v-if="isSushiHub && storeMenu" />

    <shopfooter v-if="!isSushiHub" />
    <order-type v-if="showOrderTypePopup"></order-type>
    <enter-name v-if="showEnterNamePopUp && showSharedCart" />

    </div>
    <order-placed v-if="getModalProp" />
  </div>
</template>
<script>
import ProductList from "./products/ProductList";
import ShoppingCart from "./shopping-cart/ShoppingCart";
import ResturantMenu from "./../shared/menu";
import ShopHeader from "./partials/shopheader";
import shopfooter from "./../shared/shopfooter";
import { mapMutations, mapActions, mapGetters } from "vuex";
import OrderType from "./OrderType";
import sharedScripts from '../../sharedscripts/shop/Shop';
import TermsAndCondition from "@/components/sushiHub/termsAndCondition";
import SushiNav from "@/components/sushiHub/sushiNav";
import { orderTypeHelper } from "../../api/helpers/orderTypeHelper";
import { CONSTANT_ORDER_TYPE_DINEIN } from "../../constans/strings";
import EnterName from "../user/EnterName.vue";
import OrderPlaced from '../shared/OrderPlaced.vue';
export default {
  components: {
    SushiNav,
    TermsAndCondition,
    ProductList,
    ShoppingCart,
    ResturantMenu,
    ShopHeader,
    shopfooter,
    OrderType,
    EnterName,
    OrderPlaced,
  },
  props: {
    storeid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      productListClass: "col-xl-8 col-md-7 col-sm-6",
      shoppingCartClass: "col-xl-4 col-md-5 col-sm-6",
      showOrderTypeSelection: true,
      multipleMenus: true,

      // check if the store has multiple menus
      loading: true,
    };
  },
  computed: {
    ...sharedScripts.computed,
    ...mapGetters([
      "storeMenu",
      "desktopStyles",
      "getloadedMenu",
      "isDigitalDisplay",
      "currentStoreDoc",
      "selectedCompany",
      "showSharedCart",
      "getModalProp",
    ]),
    computeProductListClass() {
      if (this.isDigitalDisplay) {
        return "col-xl-12 col-md-12 col-sm-12";
      } else {
        return this.productListClass;
      }
    },
    isSushiHub() {
      return this.hqDoc && this.hqDoc.IsSushiHub
    },
    showOrderTypePopup() {
      return (
          !this.loading &&
          this.showOrderTypeSelection &&
          this.multipleMenus &&
          !this.$route.query.table
      );
    },
    showEnterNamePopUp() {
      return this.$route.query.table;
    }
  },
  watch: {
    ...sharedScripts.watch,
  },
  created() {
    if(this.currentStoreDoc && this.storeid != this.currentStoreDoc.ID)
    {
      this.setCurrentStoreDoc(null);
    }
    if (
        this.currentStoreDoc &&
        this.currentStoreDoc.ViewComponentConfigs.MultipleMenus === false
    ) {
      this.multipleMenus = false;
    }
    if (this.$route.query.table) {
      orderTypeHelper.setOrderTypeDineIn();
      this.setSelectedMenuType(CONSTANT_ORDER_TYPE_DINEIN);
    }
  },
  mounted() {
    const self = this;
    this.setStore(this.storeid);
    this.initStore({
      storeId: this.storeid,
      callback: () => {
        self.initiateWorkflow();
        self.setStoreLoaded();
        this.loading = false;
      },
    });
    this.getStoreMenu(this.storeid);
    this.getProductStatuses(this.storeid);

    this.setShowDeliveryFee(true);
    this.updateShoppingCartItems();
  },
  updated() {
    if (this.showSharedCart) {
      this.getTableOrder(this.storeid);
    }
  },
  methods: {
    ...sharedScripts.methods,
    ...mapMutations(["setStore", "setStoreLoaded", "setShowDeliveryFee","setCurrentStoreDoc"]),
    ...mapActions([
      "initStore",
      "getStoreMenu",
      "insertErrorlog",
      "redirectToErrorPage",
      "updateShoppingCartItems",
      "getProductStatuses",
      "getTableOrder",
    ]),
    setMenu() {
      return JSON.parse(JSON.stringify(this.storeMenu));
    },
    updateWidth(width) {
      if (width > 992) {
        this.productListClass = "col-xl-8 col-md-7 col-sm-6";
        this.shoppingCartClass = "col-xl-4 col-md-5 col-sm-6";
      } else {
        this.productListClass = "col-xl-6 col-md-6 col-sm-6";
        this.shoppingCartClass = "col-xl-6 col-md-6 col-sm-6";
      }
    }
  }
};
</script>
